import {message} from "antd";
import api from "../services/api";

function filenameFromContentDisposition(header) {
    if (!header) return null;
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header);
    return match ? decodeURIComponent(match[1]) : null;
}

async function parseBlobError(errorResponse) {
    const DEFAULT_MESSAGE = 'Erro ao baixar arquivo.';
    if (!errorResponse) return DEFAULT_MESSAGE;

    const {data} = errorResponse;
    if (data instanceof Blob && data.type === 'application/json') {
        try {
            const text = await data.text();
            const parsed = JSON.parse(text);
            return parsed.detail || DEFAULT_MESSAGE;
        } catch {
            return DEFAULT_MESSAGE;
        }
    }
    return DEFAULT_MESSAGE;
}

// Baixa um arquivo do backend (CSV/PDF) via blob e dispara o download no navegador.
export async function downloadFile({url, params, filename}) {
    try {
        const response = await api.get(url, {params, responseType: 'blob'});
        const resolvedFilename = filenameFromContentDisposition(response.headers?.['content-disposition']) || filename;

        const blobUrl = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = resolvedFilename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
    } catch (error) {
        const errorMessage = await parseBlobError(error.response);
        message.error(errorMessage);
        throw error;
    }
}
